<template>
  <div>
    <div class="breadcrumb">
      <div class="container">
        <ul>
          <li><router-link to="/">HARUMIFLAG</router-link></li>
          <li><router-link to="/coming-soon">Coming Soon</router-link></li>
        </ul>
      </div>
    </div>
    <div class="shop-guide coming-soon">
      <div class="container">
        <div class="container-child">
          <div class="shop-guide__title">
            <h2>COMING SOON<span>準備中</span></h2>
          </div>
          <div class="main-img">
            <img
              src="@/assets/img/coming-soon/ComingSoon.jpg"
              alt="coming-soon"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { RouterLink } from "vue-router";

export default {
  name: "ComingSoon",
  components: {
  },
  data() {
    return {
    };
  },
};
</script>
